import { apiRequest } from "../../../shared/api/client";
import type { CapaRecord } from "../domain/models";

export const capaGateway = {
  list: () => apiRequest<CapaRecord[]>("/api/quality/capa"),
  create: (input: Record<string, unknown>) =>
    apiRequest<CapaRecord>("/api/quality/capa", {
      method: "POST",
      body: JSON.stringify(input),
    }),
  evaluate: (id: string, input: Record<string, unknown>) =>
    apiRequest<CapaRecord>(`/api/quality/capa/${id}/evaluate`, {
      method: "POST",
      body: JSON.stringify(input),
    }),
  completeAction: (id: string, input: Record<string, unknown>) =>
    apiRequest<CapaRecord>(`/api/quality/capa/${id}/complete-action`, {
      method: "POST",
      body: JSON.stringify(input),
    }),
  verify: (id: string, input: Record<string, unknown>) =>
    apiRequest<CapaRecord>(`/api/quality/capa/${id}/verify`, {
      method: "POST",
      body: JSON.stringify(input),
    }),
};
